$( document ).on ( 'areaReady' , function ( event ) {
    $( '.js-captcha' , event.target ).each ( function () {        
        var refresh = function () {
            img.attr ( 'src' , 'index.php?module=captcha&index[captcha][action]=image&index[captcha][challenge]=' + challenge + '&ajax=TRUE&' + new Date().getTime() ) ;
        }

        var challenge = $( '.js-captcha_challenge' ).val () ;
        var img = $( '<img class="captcha__img" width="180" height="60" />' ) ;
        var a = $( '<button type="button" class="btn btn--square captcha__refresh"><span class="js-icon" data-icon="refresh"></span><span class="hidden">Reload Captcha</span></a>' ).on ( 'click' , function () { refresh () ; } ).click () ;

        $( this ).append ( img ).append ( a ) ;
    } );
} ) ;
